import { render, staticRenderFns } from "./cardMedallas.vue?vue&type=template&id=8ad5b6a4&scoped=true"
import script from "./cardMedallas.vue?vue&type=script&lang=js"
export * from "./cardMedallas.vue?vue&type=script&lang=js"
import style0 from "./cardMedallas.vue?vue&type=style&index=0&id=8ad5b6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad5b6a4",
  null
  
)

export default component.exports